import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["backdrop", "panel"];

  open() {
    this.backdropTarget.hidden = false;
    this.panelTarget.dataset.open = "true";
  }

  close() {
    this.backdropTarget.hidden = true;
    this.panelTarget.dataset.open = "false";
  }
}
